/* eslint semi:0 */
import { node, } from 'utils/dom'
import { makeSafeFn, } from 'utils/fn'
import { addWindowEvent, } from 'utils/window'
import { riddle, } from 'config/externalScripts'
import { registerProvider, } from 'application/nm'
import { external as externalScriptsLoader, } from 'utils/script'
import analyticsActions from 'organizedByType/actions/analyticsActions'


const RIDDLE_EMBED_SELECTOR = '.riddle_target'
const w = window;


// Riddle documentation: http://blog.riddle.com/google-event-tracking/
// Riddle example: https://examples.riddle.com/google-analytics.php
function filterRiddleMessage({ data, }) {
  if (data && data.riddleEvent) {
    const riddleData = data.riddleEvent;
    if (typeof riddleData === 'object') {
      analyticsActions.riddleEmbedMessage(riddleData);
    }
  }
}

function addOnMessageHandlerAndInitRiddle() {
  addWindowEvent("message", filterRiddleMessage, true);
  return makeSafeFn(() => w.riddleAPI.update());
}

export default function initRiddleEmbeds(){
  if (node(RIDDLE_EMBED_SELECTOR)) {
    const riddleLoader = externalScriptsLoader.load({ name: riddle.name, });
    riddleLoader(addOnMessageHandlerAndInitRiddle);
    return true;
  }
  return false;
}

registerProvider({ initRiddleEmbeds, });


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/riddle/riddleEmbedProvider.js